import React from "react";
import CustomerLinksTable from "../../../Components/Agent/SearchAgent/CustomerLinksTable/CustomerLinksTable";

export default function CrmOffersTab() {
  return (
    <div className="crm-offers-tab">
      <CustomerLinksTable pageType="drafts" />
    </div>
  );
}
